// Move Wishlist button above the "Buy it Now" button
document.addEventListener('DOMContentLoaded', () => {
    const wishlistBtn = document.querySelector('.xb-wishlist-button');
    if (wishlistBtn) {
        const wishlistSection = wishlistBtn.closest('section');
        const checkoutBtnDiv = document.querySelector('.product-form__checkout');
        if (wishlistSection && checkoutBtnDiv && wishlistSection !== checkoutBtnDiv.previousElementSibling) {
            const wishlistContainer = wishlistSection?.querySelector('.container');
            if (wishlistContainer) {
                wishlistContainer.style.padding = '0';
            }

            checkoutBtnDiv.parentNode.insertBefore(wishlistSection, checkoutBtnDiv);
        } 
    }
});